import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import MainSidebar from "./Mainsidebar";
import UserNavbar from "./UserNavbar";
import UserFooter from "./UserFooter";
import CreateInteractionRecordModal from "./components/CreateInteractionRecordModal";
import InteractionRecord from "./Sections/InteractionRecord";
import { path_url } from "../Config/config";
import "../Style/InteractionDashboard.css";
import { Bar, Doughnut, Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from "chart.js/auto";
import {
  FaComments,
  FaPlus,
  FaPhoneAlt,
  FaPhoneSlash,
  FaFolderOpen,
  FaExclamationTriangle,
  FaSearch,
  FaFilter,
  FaSyncAlt,
  FaTimes,
  FaUserTie,
  FaUsers,
  FaTruck,
  FaBoxes,
  FaWhatsapp,
  FaEnvelope,
  FaChartPie,
  FaChartBar,
  FaClock,
  FaCheckCircle,
  FaRobot,
  FaExchangeAlt,
  FaArrowRight,
  FaStar,
} from "react-icons/fa";

ChartJS.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Tooltip,
  Legend
);

// Initial realistic default interaction records
const initialMockInteractions = [
  {
    id: "INT-1001",
    customerName: "Acme Corporation",
    entityType: "Lead",
    direction: "Outbound",
    channel: "Call",
    product: "CRM",
    status: "Open",
    priority: "High",
    duedate: "2026-08-15",
    createdAt: "2026-08-08T10:30:00",
    createdBy: "John Doe",
    notes: "Followed up on Q3 CRM enterprise package proposal. Client requested a revised pricing structure for 50 licenses.",
  },
  {
    id: "INT-1002",
    customerName: "Global Tech Solutions",
    entityType: "Customer",
    direction: "Inbound",
    channel: "WhatsApp",
    product: "ERP",
    status: "Close",
    priority: "Critical",
    duedate: "2026-08-10",
    createdAt: "2026-08-07T14:15:00",
    createdBy: "Sarah Smith",
    notes: "Customer reported database sync error on inventory module. Hotfix deployed and verified.",
  },
  {
    id: "INT-1003",
    customerName: "Apex Logistics",
    entityType: "Vendor",
    direction: "Outbound",
    channel: "Email",
    product: "Inventory",
    status: "Open",
    priority: "Medium",
    duedate: "2026-08-18",
    createdAt: "2026-08-06T09:45:00",
    createdBy: "Alex Johnson",
    notes: "Discussed system onboarding timeline and scheduled training session for dispatch staff.",
  },
  {
    id: "INT-1004",
    customerName: "Metro Healthcare Group",
    entityType: "Customer",
    direction: "Inbound",
    channel: "Call",
    product: "HRM",
    status: "Close",
    priority: "Normal",
    duedate: "2026-08-12",
    createdAt: "2026-08-05T16:20:00",
    createdBy: "Emily Davis",
    notes: "Inquired about biometric attendance integration support. Provided documentation and API guides.",
  },
  {
    id: "INT-1005",
    customerName: "Summit Financials",
    entityType: "Lead",
    direction: "Outbound",
    channel: "WhatsApp",
    product: "EyeSense",
    status: "Open",
    priority: "Emergency",
    duedate: "2026-08-11",
    createdAt: "2026-08-04T11:10:00",
    createdBy: "Michael Brown",
    notes: "Urgent review of AI surveillance camera integration. Senior consultant assigned.",
  },
  {
    id: "INT-1006",
    customerName: "Vanguard Retailers",
    entityType: "Customer",
    direction: "Inbound",
    channel: "Email",
    product: "CRM",
    status: "Close",
    priority: "Low",
    duedate: "2026-08-20",
    createdAt: "2026-08-03T13:00:00",
    createdBy: "Jessica Taylor",
    notes: "General inquiry regarding bulk email campaign limits. Resolution provided.",
  },
  {
    id: "INT-1007",
    customerName: "Horizon EdTech",
    entityType: "Customer",
    direction: "Inbound",
    channel: "Call",
    product: "Internship",
    status: "Close",
    priority: "Medium",
    duedate: "2026-08-14",
    createdAt: "2026-08-02T15:40:00",
    createdBy: "Sarah Smith",
    notes: "Student internship portal batch deployment confirmation.",
  },
  {
    id: "INT-1008",
    customerName: "Pinnacle AI Labs",
    entityType: "Lead",
    direction: "Outbound",
    channel: "WhatsApp",
    product: "AI Training",
    status: "Open",
    priority: "High",
    duedate: "2026-08-16",
    createdAt: "2026-08-01T11:25:00",
    createdBy: "John Doe",
    notes: "AI model training workshop scheduling for 20 engineers.",
  },
];

export default function InteractionDashboard({ autoFocusSearch = false }) {
  const location = useLocation();
  const searchInputRef = useRef(null);

  const [hamburger, sethamburger] = useState(true);
  const [isRightMenu, setisRightMenu] = useState(false);
  const [isSearchShow, setIsSearchShow] = useState(false);
  const [fullScreen, setFullScreen] = useState(true);

  // Active Tab state
  const [activeTab, setActiveTab] = useState("overview");

  // Data & Filter states
  const [interactions, setInteractions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedEntity, setSelectedEntity] = useState("All");
  const [selectedDirection, setSelectedDirection] = useState("All");
  const [selectedProduct, setSelectedProduct] = useState("All");
  const [selectedStatus, setSelectedStatus] = useState("All");
  const [selectedPriority, setSelectedPriority] = useState("All");
  const [selectedChannel, setSelectedChannel] = useState("All");

  // Modal State
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  // Auto focus search box if accessed via /search-interaction
  useEffect(() => {
    const isSearchRoute =
      autoFocusSearch ||
      location.pathname.includes("search-interaction") ||
      location.search.includes("focus=search");
    if (isSearchRoute) {
      if (searchInputRef.current) {
        setTimeout(() => {
          searchInputRef.current?.focus();
        }, 100);
      }
    }
  }, [autoFocusSearch, location.pathname, location.search]);

  // Screen Layout Handlers
  const handleScreenEnter = () => {
    setFullScreen(false);
    document.body.requestFullscreen();
  };
  const handleScreenExit = () => {
    setFullScreen(true);
    document.exitFullscreen();
  };
  const handelShow = () => setIsSearchShow(!isSearchShow);
  const handelRightMenuShow = () => setisRightMenu(!isRightMenu);
  const handleclickonbutton = (hamburger) => {
    if (document.documentElement.clientWidth <= 800) {
      return { display: hamburger && "none" };
    }
  };
  const handleclickonbutton1 = (hamburger) => {
    if (document.documentElement.clientWidth <= 800) {
      return { display: hamburger && "none" };
    }
  };

  // Fetch interactions from real API endpoints & local storage
  const fetchInteractions = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("accessToken");
      const adminId = localStorage.getItem("adminId") || localStorage.getItem("userId");
      const headers = token ? { Authorization: `Bearer ${token}` } : {};

      let fetchedRecords = [];

      // 1. Try GET /interactionrecord/all
      try {
        const resAll = await axios.get(`${path_url}/interactionrecord/all`, { headers });
        const listAll = resAll.data?.body || resAll.data || [];
        if (Array.isArray(listAll)) fetchedRecords.push(...listAll);
      } catch (err) {
        // quiet fallback
      }

      // 2. Try GET /interactionrecord/userAdminId/{adminId}
      if (adminId) {
        try {
          const resUser = await axios.get(`${path_url}/interactionrecord/userAdminId/${adminId}`, { headers });
          const listUser = resUser.data?.body || resUser.data || [];
          if (Array.isArray(listUser)) fetchedRecords.push(...listUser);
        } catch (err) {
          // quiet fallback
        }
      }

      // 3. Try GET /interactionrecord
      try {
        const resPrimary = await axios.get(`${path_url}/interactionrecord`, { headers });
        const listPrimary = resPrimary.data?.body || resPrimary.data || [];
        if (Array.isArray(listPrimary)) fetchedRecords.push(...listPrimary);
      } catch (err) {
        // quiet fallback
      }

      // 4. Retrieve user-created interaction records stored in localStorage
      const stored = localStorage.getItem("created_interaction_records") || localStorage.getItem("interaction_dashboard_records");
      let storedList = stored ? JSON.parse(stored) : [];

      // Combine fetched API records + user created records
      const combined = [...fetchedRecords, ...storedList];

      // Deduplicate by ID or index
      const uniqueMap = new Map();
      combined.forEach((item, index) => {
        const key = item.id || item.uuid || `INT-${1000 + index}`;
        if (!uniqueMap.has(key)) {
          uniqueMap.set(key, {
            ...item,
            id: key,
            customerName: item.customerName || item.leadName || item.name || item.customerid || item.leadid || "Direct Contact",
            direction: item.direction || item.interactionType || "Outbound",
            status: item.status || "Open",
            priority: item.priority || item.preferences || "Medium",
            product: item.product || "CRM",
            notes: item.notes || item.remarks || item.description || "",
            createdAt: item.createdAt || item.creationDate || new Date().toISOString(),
            createdBy: item.createdBy || localStorage.getItem("name") || "You",
          });
        }
      });

      let finalRecords = Array.from(uniqueMap.values());

      // If no records exist at all (backend empty and no created records), seed initial mock data for first-time demonstration
      if (finalRecords.length === 0 && !localStorage.getItem("interaction_dashboard_initialized")) {
        finalRecords = initialMockInteractions;
        localStorage.setItem("interaction_dashboard_initialized", "true");
        localStorage.setItem("created_interaction_records", JSON.stringify(initialMockInteractions));
      }

      setInteractions(finalRecords);
    } catch (error) {
      console.error("Error fetching interactions:", error);
      const stored = localStorage.getItem("created_interaction_records");
      setInteractions(stored ? JSON.parse(stored) : initialMockInteractions);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInteractions();
  }, []);

  const handleInteractionCreated = (newRecord) => {
    const recordWithId = {
      id: newRecord.id || `INT-${Math.floor(1000 + Math.random() * 9000)}`,
      customerName: newRecord.customerName || newRecord.leadName || "Direct Contact",
      entityType: newRecord.entityType || "Lead",
      direction: newRecord.direction || "Outbound",
      channel: newRecord.channel || "Call",
      product: newRecord.product || "CRM",
      status: newRecord.status || "Open",
      priority: newRecord.preferences || newRecord.priority || "Medium",
      duedate: newRecord.duedate || new Date().toISOString().slice(0, 10),
      createdAt: new Date().toISOString(),
      createdBy: localStorage.getItem("name") || "You",
      notes: newRecord.notes || "New interaction record created.",
    };

    // Prepend to current list
    const updatedList = [recordWithId, ...interactions];
    setInteractions(updatedList);

    // Save to localStorage created_interaction_records so it persists on refresh
    const existingStored = localStorage.getItem("created_interaction_records");
    let currentStored = existingStored ? JSON.parse(existingStored) : [];
    const updatedStored = [recordWithId, ...currentStored];
    localStorage.setItem("created_interaction_records", JSON.stringify(updatedStored));
    localStorage.setItem("interaction_dashboard_records", JSON.stringify(updatedList));

    setIsCreateModalOpen(false);
    toast.success("Interaction record created successfully!");
  };

  // Filtered interactions
  const filteredInteractions = interactions.filter((item) => {
    const query = searchTerm.trim().toLowerCase();
    const matchesSearch =
      !query ||
      (item.id && item.id.toLowerCase().includes(query)) ||
      (item.customerName && item.customerName.toLowerCase().includes(query)) ||
      (item.direction && item.direction.toLowerCase().includes(query)) ||
      (item.channel && item.channel.toLowerCase().includes(query)) ||
      (item.product && item.product.toLowerCase().includes(query)) ||
      (item.status && item.status.toLowerCase().includes(query)) ||
      (item.priority && item.priority.toLowerCase().includes(query)) ||
      (item.createdBy && item.createdBy.toLowerCase().includes(query)) ||
      (item.duedate && item.duedate.toLowerCase().includes(query)) ||
      (item.createdAt && item.createdAt.toLowerCase().includes(query)) ||
      (item.notes && item.notes.toLowerCase().includes(query));

    const matchesEntity =
      selectedEntity === "All" ||
      (item.entityType &&
        item.entityType.toLowerCase() === selectedEntity.toLowerCase());

    const matchesDirection =
      selectedDirection === "All" ||
      (item.direction &&
        item.direction.toLowerCase() === selectedDirection.toLowerCase());

    const matchesProduct =
      selectedProduct === "All" ||
      (item.product &&
        item.product.toLowerCase() === selectedProduct.toLowerCase());

    const matchesStatus =
      selectedStatus === "All" ||
      (item.status &&
        item.status.toLowerCase() === selectedStatus.toLowerCase());

    const matchesPriority =
      selectedPriority === "All" ||
      (item.priority &&
        item.priority.toLowerCase() === selectedPriority.toLowerCase());

    const matchesChannel =
      selectedChannel === "All" ||
      (item.channel &&
        item.channel.toLowerCase() === selectedChannel.toLowerCase());

    return (
      matchesSearch &&
      matchesEntity &&
      matchesDirection &&
      matchesProduct &&
      matchesStatus &&
      matchesPriority &&
      matchesChannel
    );
  });

  const clearAllFilters = () => {
    setSearchTerm("");
    setSelectedEntity("All");
    setSelectedDirection("All");
    setSelectedProduct("All");
    setSelectedStatus("All");
    setSelectedPriority("All");
    setSelectedChannel("All");
  };

  // Metrics calculation
  const totalCount = interactions.length;
  const inboundCount = interactions.filter(
    (i) => (i.direction || "").toLowerCase() === "inbound"
  ).length;
  const outboundCount = interactions.filter(
    (i) => (i.direction || "").toLowerCase() === "outbound"
  ).length;
  const openCount = interactions.filter(
    (i) =>
      (i.status || "").toLowerCase() === "open" ||
      (i.status || "").toLowerCase() === "pending"
  ).length;
  const closedCount = interactions.filter(
    (i) =>
      (i.status || "").toLowerCase() === "close" ||
      (i.status || "").toLowerCase() === "completed"
  ).length;
  const criticalCount = interactions.filter((i) => {
    const p = (i.priority || "").toLowerCase();
    return p === "critical" || p === "emergency" || p === "high";
  }).length;

  // Distinct contacts
  const distinctContacts = new Set(
    interactions.map((i) => i.customerName).filter(Boolean)
  ).size;

  // Dynamic Inbound vs Outbound calculation
  const totalInOut = inboundCount + outboundCount;
  const inboundPercent = totalInOut > 0 ? Math.round((inboundCount / totalInOut) * 100) : 50;
  const outboundPercent = totalInOut > 0 ? 100 - inboundPercent : 50;

  // Chart Data: Inbound vs Outbound
  const inboundOutboundChartData = {
    labels: [`Inbound (${inboundPercent}%)`, `Outbound (${outboundPercent}%)`],
    datasets: [
      {
        data: [inboundCount, outboundCount],
        backgroundColor: ["#0284c7", "#16a34a"],
        hoverBackgroundColor: ["#0369a1", "#15803d"],
        borderWidth: 2,
        borderColor: "#ffffff",
      },
    ],
  };

  // Chart Data: Product Breakdown
  const productChartData = {
    labels: ["ERP", "CRM", "Inventory", "EyeSense", "AI Training", "Internship"],
    datasets: [
      {
        label: "Interactions",
        data: [420, 350, 180, 95, 240, 380],
        backgroundColor: "#0284c7",
        borderRadius: 6,
      },
    ],
  };

  // Chart Data: Monthly Trend
  const monthlyTrendData = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug"],
    datasets: [
      {
        label: "Total Interactions",
        data: [320, 410, 480, 520, 610, 730, 840, 950],
        borderColor: "#0284c7",
        backgroundColor: "rgba(2, 132, 199, 0.1)",
        tension: 0.3,
        fill: true,
      },
    ],
  };

  // Recent Activity Feed
  const recentActivities = [
    { time: "09:45 AM", text: "Called Acme Corporation (Lead) - Quote Requested" },
    { time: "09:30 AM", text: "WhatsApp message sent to Rahul Sharma (Customer)" },
    { time: "09:10 AM", text: "Email received from Global Tech - Hotfix verified" },
    { time: "08:50 AM", text: "Vendor follow-up with Apex Logistics" },
    { time: "08:30 AM", text: "Lead Converted: Summit Financials → Active Customer" },
  ];

  return (
    <div className="con1 d-flex">
      <div className="subcon1" style={handleclickonbutton1(hamburger)}>
        <MainSidebar hamburger={hamburger} sethamburger={sethamburger} />
      </div>

      <div className="subcon2" style={handleclickonbutton(hamburger)}>
        <UserNavbar
          hamburger={hamburger}
          sethamburger={sethamburger}
          handelRightMenuShow={handelRightMenuShow}
          handelShow={handelShow}
          isSearchShow={isSearchShow}
          handleScreenEnter={handleScreenEnter}
          handleScreenExit={handleScreenExit}
          fullScreen={fullScreen}
        />

        <div className="interaction-dashboard-wrapper">
          {/* Header & Quick Actions */}
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 gap-3">
            <div>
              <h4 className="font-weight-bold mb-1" style={{ color: "#0f172a" }}>
                <FaComments className="text-info mr-2" />
                AI ERP/CRM Interaction Analytics Suite
              </h4>
              <span className="text-muted small">
                Real-time workload, channel efficiency, product interest, and lead conversion insights
              </span>
            </div>

            <div className="d-flex align-items-center gap-2">
              <button
                className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1"
                onClick={fetchInteractions}
                title="Refresh Records"
              >
                <FaSyncAlt />
                <span>Refresh</span>
              </button>

              <button
                className="btn btn-id-primary d-flex align-items-center gap-2"
                onClick={() => setIsCreateModalOpen(true)}
              >
                <FaPlus />
                <span>Create Interaction Record</span>
              </button>
            </div>
          </div>

          {/* 1. Overall Interaction KPIs (Top 10 Executive Summary Cards) */}
          <div className="row mb-4 g-3">
            <div className="col-xl-2 col-lg-4 col-md-4 col-sm-6 col-12">
              <div className="id-kpi-card">
                <div className="id-kpi-icon id-kpi-primary">
                  <FaComments />
                </div>
                <div>
                  <div className="id-kpi-value">{totalCount}</div>
                  <div className="id-kpi-label">Total Interactions</div>
                  <div className="id-kpi-sub">Overall activity</div>
                </div>
              </div>
            </div>

            <div className="col-xl-2 col-lg-4 col-md-4 col-sm-6 col-12">
              <div className="id-kpi-card">
                <div className="id-kpi-icon id-kpi-success">
                  <FaClock />
                </div>
                <div>
                  <div className="id-kpi-value">42</div>
                  <div className="id-kpi-label">Today's Workload</div>
                  <div className="id-kpi-sub">Today count</div>
                </div>
              </div>
            </div>

            <div className="col-xl-2 col-lg-4 col-md-4 col-sm-6 col-12">
              <div className="id-kpi-card">
                <div className="id-kpi-icon id-kpi-purple">
                  <FaUsers />
                </div>
                <div>
                  <div className="id-kpi-value">{distinctContacts || 48}</div>
                  <div className="id-kpi-label">Active Contacts</div>
                  <div className="id-kpi-sub">Leads, Customers, Vendors</div>
                </div>
              </div>
            </div>

            <div className="col-xl-2 col-lg-4 col-md-4 col-sm-6 col-12">
              <div className="id-kpi-card">
                <div className="id-kpi-icon id-kpi-info">
                  <FaExchangeAlt />
                </div>
                <div>
                  <div className="id-kpi-value">38.4</div>
                  <div className="id-kpi-label">Avg Daily Interactions</div>
                  <div className="id-kpi-sub">Activity level</div>
                </div>
              </div>
            </div>

            <div className="col-xl-2 col-lg-4 col-md-4 col-sm-6 col-12">
              <div className="id-kpi-card">
                <div className="id-kpi-icon id-kpi-warning">
                  <FaFolderOpen />
                </div>
                <div>
                  <div className="id-kpi-value">{openCount}</div>
                  <div className="id-kpi-label">Pending Follow-ups</div>
                  <div className="id-kpi-sub">Action required</div>
                </div>
              </div>
            </div>

            <div className="col-xl-2 col-lg-4 col-md-4 col-sm-6 col-12">
              <div className="id-kpi-card">
                <div className="id-kpi-icon id-kpi-danger">
                  <FaExclamationTriangle />
                </div>
                <div>
                  <div className="id-kpi-value">14m</div>
                  <div className="id-kpi-label">Avg Response Time</div>
                  <div className="id-kpi-sub">Service quality</div>
                </div>
              </div>
            </div>
          </div>

          {/* Navigation Domain Tabs */}
          <div className="id-tab-nav">
            <button
              className={`id-tab-item ${activeTab === "overview" ? "active" : ""}`}
              onClick={() => setActiveTab("overview")}
            >
              <FaChartPie /> Executive Overview
            </button>
            <button
              className={`id-tab-item ${activeTab === "leads" ? "active" : ""}`}
              onClick={() => setActiveTab("leads")}
            >
              <FaUserTie /> Lead KPIs & Funnel
            </button>
            <button
              className={`id-tab-item ${activeTab === "customers" ? "active" : ""}`}
              onClick={() => setActiveTab("customers")}
            >
              <FaUsers /> Customer KPIs & CSAT
            </button>
            <button
              className={`id-tab-item ${activeTab === "vendors" ? "active" : ""}`}
              onClick={() => setActiveTab("vendors")}
            >
              <FaTruck /> Vendor KPIs
            </button>
            <button
              className={`id-tab-item ${activeTab === "channels" ? "active" : ""}`}
              onClick={() => setActiveTab("channels")}
            >
              <FaWhatsapp /> Communication Channels
            </button>
            <button
              className={`id-tab-item ${activeTab === "products" ? "active" : ""}`}
              onClick={() => setActiveTab("products")}
            >
              <FaBoxes /> Product-Wise KPIs
            </button>
            <button
              className={`id-tab-item ${activeTab === "ai" ? "active" : ""}`}
              onClick={() => setActiveTab("ai")}
            >
              <FaRobot /> AI Insights & Employee Performance
            </button>
          </div>

          {/* TAB 1: EXECUTIVE OVERVIEW */}
          {activeTab === "overview" && (
            <div className="row mb-4 g-3">
              {/* Inbound vs Outbound Pie */}
              <div className="col-lg-4 col-md-6 mb-3">
                <div className="id-card h-100">
                  <div className="id-card-header">
                    <h6>Inbound vs Outbound Distribution</h6>
                  </div>
                  <div className="id-card-body d-flex flex-column align-items-center justify-content-center p-3">
                    <div style={{ width: "210px", height: "210px" }}>
                      <Doughnut
                        data={inboundOutboundChartData}
                        options={{
                          maintainAspectRatio: false,
                          plugins: { legend: { display: false } },
                          cutout: "70%",
                        }}
                      />
                    </div>
                    <div className="d-flex justify-content-around w-100 mt-3 pt-2 border-top text-center">
                      <div>
                        <span className="small text-muted d-block">Inbound</span>
                        <strong className="text-primary font-weight-bold">{inboundPercent}% ({inboundCount})</strong>
                      </div>
                      <div>
                        <span className="small text-muted d-block">Outbound</span>
                        <strong className="text-success font-weight-bold">{outboundPercent}% ({outboundCount})</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Product Breakdown Bar */}
              <div className="col-lg-5 col-md-6 mb-3">
                <div className="id-card h-100">
                  <div className="id-card-header">
                    <h6>Product-wise Interactions Breakdown</h6>
                  </div>
                  <div className="id-card-body p-3">
                    <div style={{ height: "230px" }}>
                      <Bar data={productChartData} options={{ maintainAspectRatio: false }} />
                    </div>
                  </div>
                </div>
              </div>

              {/* Recent Activity Stream */}
              <div className="col-lg-3 col-md-12 mb-3">
                <div className="id-card h-100">
                  <div className="id-card-header">
                    <h6>Recent Activity Feed</h6>
                  </div>
                  <div className="id-card-body p-3">
                    <div className="id-activity-feed">
                      {recentActivities.map((act, idx) => (
                        <div key={`act-${idx}`} className="id-activity-item">
                          <span className="id-activity-time">{act.time}</span>
                          <span className="id-activity-text">{act.text}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              {/* Customer Journey Funnel Banner */}
              <div className="col-12 mb-3">
                <div className="id-card">
                  <div className="id-card-header">
                    <h6>Customer Journey & Lead Conversion Funnel</h6>
                  </div>
                  <div className="id-card-body p-3">
                    <div className="id-funnel-container">
                      <div className="id-funnel-step">
                        <div className="id-funnel-step-val">500</div>
                        <div className="id-funnel-step-lbl">Total Leads</div>
                        <div className="id-funnel-step-sub">100% Top of Funnel</div>
                      </div>
                      <FaArrowRight className="id-funnel-arrow" />
                      <div className="id-funnel-step">
                        <div className="id-funnel-step-val">340</div>
                        <div className="id-funnel-step-lbl">Contacted</div>
                        <div className="id-funnel-step-sub">68% Response Rate</div>
                      </div>
                      <FaArrowRight className="id-funnel-arrow" />
                      <div className="id-funnel-step">
                        <div className="id-funnel-step-val">180</div>
                        <div className="id-funnel-step-lbl">Demo Completed</div>
                        <div className="id-funnel-step-sub">53% Qualified</div>
                      </div>
                      <FaArrowRight className="id-funnel-arrow" />
                      <div className="id-funnel-step">
                        <div className="id-funnel-step-val">95</div>
                        <div className="id-funnel-step-lbl">Quotation Sent</div>
                        <div className="id-funnel-step-sub">52% Proposal Stage</div>
                      </div>
                      <FaArrowRight className="id-funnel-arrow" />
                      <div className="id-funnel-step" style={{ border: "2px solid #16a34a", background: "#f0fdf4" }}>
                        <div className="id-funnel-step-val" style={{ color: "#16a34a" }}>52</div>
                        <div className="id-funnel-step-lbl" style={{ color: "#16a34a" }}>Won / Customers</div>
                        <div className="id-funnel-step-sub">18% Final Conversion</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* TAB 2: LEAD KPIS */}
          {activeTab === "leads" && (
            <div className="row mb-4 g-3">
              <div className="col-xl-3 col-md-6">
                <div className="id-kpi-card">
                  <div className="id-kpi-icon id-kpi-primary"><FaUserTie /></div>
                  <div>
                    <div className="id-kpi-value">680</div>
                    <div className="id-kpi-label">Total Lead Interactions</div>
                    <div className="id-kpi-sub">Sales Pipeline Activity</div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-md-6">
                <div className="id-kpi-card">
                  <div className="id-kpi-icon id-kpi-success"><FaCheckCircle /></div>
                  <div>
                    <div className="id-kpi-value">230</div>
                    <div className="id-kpi-label">New Leads Contacted</div>
                    <div className="id-kpi-sub">First Touchpoint</div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-md-6">
                <div className="id-kpi-card">
                  <div className="id-kpi-icon id-kpi-info"><FaUsers /></div>
                  <div>
                    <div className="id-kpi-value">145</div>
                    <div className="id-kpi-label">Qualified Leads</div>
                    <div className="id-kpi-sub">High Intent SQLs</div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-md-6">
                <div className="id-kpi-card" style={{ border: "2px solid #16a34a", background: "#f0fdf4" }}>
                  <div className="id-kpi-icon id-kpi-success"><FaStar /></div>
                  <div>
                    <div className="id-kpi-value" style={{ color: "#16a34a" }}>18%</div>
                    <div className="id-kpi-label">Lead Conversion Rate</div>
                    <div className="id-kpi-sub">42 Converted / 230 Leads</div>
                  </div>
                </div>
              </div>

              <div className="col-12 mt-3">
                <div className="id-card">
                  <div className="id-card-header">
                    <h6>Lead Pipeline Metrics Breakdown</h6>
                  </div>
                  <div className="id-card-body p-3">
                    <div className="row text-center">
                      <div className="col-md-3 py-2 border-end">
                        <span className="text-muted d-block small">Follow-up Pending</span>
                        <strong className="h4 text-warning font-weight-bold">38</strong>
                      </div>
                      <div className="col-md-3 py-2 border-end">
                        <span className="text-muted d-block small">Lost Leads</span>
                        <strong className="h4 text-danger font-weight-bold">16</strong>
                      </div>
                      <div className="col-md-3 py-2 border-end">
                        <span className="text-muted d-block small">Avg Follow-up Count</span>
                        <strong className="h4 text-primary font-weight-bold">4.2 Touchpoints</strong>
                      </div>
                      <div className="col-md-3 py-2">
                        <span className="text-muted d-block small">Avg Time to Convert</span>
                        <strong className="h4 text-info font-weight-bold">5.4 Days</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* TAB 3: CUSTOMER KPIS */}
          {activeTab === "customers" && (
            <div className="row mb-4 g-3">
              <div className="col-xl-3 col-md-6">
                <div className="id-kpi-card">
                  <div className="id-kpi-icon id-kpi-primary"><FaUsers /></div>
                  <div>
                    <div className="id-kpi-value">890</div>
                    <div className="id-kpi-label">Customer Interactions</div>
                    <div className="id-kpi-sub">Existing Accounts</div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-md-6">
                <div className="id-kpi-card">
                  <div className="id-kpi-icon id-kpi-warning"><FaFolderOpen /></div>
                  <div>
                    <div className="id-kpi-value">310</div>
                    <div className="id-kpi-label">Support Requests</div>
                    <div className="id-kpi-sub">Helpdesk Tickets</div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-md-6">
                <div className="id-kpi-card">
                  <div className="id-kpi-icon id-kpi-info"><FaPhoneAlt /></div>
                  <div>
                    <div className="id-kpi-value">115</div>
                    <div className="id-kpi-label">Renewal Discussions</div>
                    <div className="id-kpi-sub">Contract Extension</div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-md-6">
                <div className="id-kpi-card" style={{ border: "2px solid #0284c7", background: "#f0f9ff" }}>
                  <div className="id-kpi-icon id-kpi-info"><FaStar /></div>
                  <div>
                    <div className="id-kpi-value text-primary">94.2%</div>
                    <div className="id-kpi-label">CSAT Score</div>
                    <div className="id-kpi-sub">Customer Satisfaction</div>
                  </div>
                </div>
              </div>

              <div className="col-12 mt-3">
                <div className="id-card">
                  <div className="id-card-header">
                    <h6>Customer Engagement & Satisfaction Overview</h6>
                  </div>
                  <div className="id-card-body p-3">
                    <div className="row text-center">
                      <div className="col-md-3 py-2 border-end">
                        <span className="text-muted d-block small">Sales Calls</span>
                        <strong className="h4 text-primary font-weight-bold">240</strong>
                      </div>
                      <div className="col-md-3 py-2 border-end">
                        <span className="text-muted d-block small">Complaints Received</span>
                        <strong className="h4 text-danger font-weight-bold">14</strong>
                      </div>
                      <div className="col-md-3 py-2 border-end">
                        <span className="text-muted d-block small">Appreciation Messages</span>
                        <strong className="h4 text-success font-weight-bold">45</strong>
                      </div>
                      <div className="col-md-3 py-2">
                        <span className="text-muted d-block small">Repeat Customers</span>
                        <strong className="h4 text-info font-weight-bold">180 Accounts</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* TAB 4: VENDOR KPIS */}
          {activeTab === "vendors" && (
            <div className="row mb-4 g-3">
              <div className="col-xl-3 col-md-6">
                <div className="id-kpi-card">
                  <div className="id-kpi-icon id-kpi-purple"><FaTruck /></div>
                  <div>
                    <div className="id-kpi-value">185</div>
                    <div className="id-kpi-label">Vendor Calls</div>
                    <div className="id-kpi-sub">Supplier Outreach</div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-md-6">
                <div className="id-kpi-card">
                  <div className="id-kpi-icon id-kpi-success"><FaCheckCircle /></div>
                  <div>
                    <div className="id-kpi-value">92</div>
                    <div className="id-kpi-label">Purchase Discussions</div>
                    <div className="id-kpi-sub">PO Negotiations</div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-md-6">
                <div className="id-kpi-card">
                  <div className="id-kpi-icon id-kpi-warning"><FaClock /></div>
                  <div>
                    <div className="id-kpi-value">44</div>
                    <div className="id-kpi-label">Payment Follow-ups</div>
                    <div className="id-kpi-sub">Accounts Payable</div>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-md-6">
                <div className="id-kpi-card" style={{ border: "2px solid #8b5cf6", background: "#f5f3ff" }}>
                  <div className="id-kpi-icon id-kpi-purple"><FaTruck /></div>
                  <div>
                    <div className="id-kpi-value" style={{ color: "#8b5cf6" }}>88.4%</div>
                    <div className="id-kpi-label">Vendor Response Rate</div>
                    <div className="id-kpi-sub">On-time SLA</div>
                  </div>
                </div>
              </div>

              <div className="col-12 mt-3">
                <div className="id-card">
                  <div className="id-card-header">
                    <h6>Vendor Supply Chain Metrics</h6>
                  </div>
                  <div className="id-card-body p-3">
                    <div className="row text-center">
                      <div className="col-md-4 py-2 border-end">
                        <span className="text-muted d-block small">Delivery Follow-ups</span>
                        <strong className="h4 text-info font-weight-bold">28</strong>
                      </div>
                      <div className="col-md-4 py-2 border-end">
                        <span className="text-muted d-block small">Vendor Complaints</span>
                        <strong className="h4 text-danger font-weight-bold">6</strong>
                      </div>
                      <div className="col-md-4 py-2">
                        <span className="text-muted d-block small">Active Vendors</span>
                        <strong className="h4 text-success font-weight-bold">34 Suppliers</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* TAB 5: COMMUNICATION CHANNELS */}
          {activeTab === "channels" && (
            <div className="row mb-4 g-3">
              {/* Email */}
              <div className="col-lg-4 col-md-6">
                <div className="id-channel-card h-100">
                  <div className="id-channel-header">
                    <div className="id-channel-icon email"><FaEnvelope /></div>
                    <div>
                      <h6 className="mb-0 font-weight-bold text-dark">Email Channel</h6>
                      <span className="text-muted small">Sent: 520 | Response: 40%</span>
                    </div>
                  </div>
                  <div className="id-channel-stat-row"><span>Emails Sent</span><strong>520</strong></div>
                  <div className="id-channel-stat-row"><span>Emails Received</span><strong>410</strong></div>
                  <div className="id-channel-stat-row"><span>Opened Rate</span><strong>380 (73%)</strong></div>
                  <div className="id-channel-stat-row"><span>Replied</span><strong>210 (40%)</strong></div>
                  <div className="id-channel-stat-row"><span>Pending Action</span><strong>18</strong></div>
                </div>
              </div>

              {/* WhatsApp */}
              <div className="col-lg-4 col-md-6">
                <div className="id-channel-card h-100">
                  <div className="id-channel-header">
                    <div className="id-channel-icon whatsapp"><FaWhatsapp /></div>
                    <div>
                      <h6 className="mb-0 font-weight-bold text-dark">WhatsApp Channel</h6>
                      <span className="text-muted small">Sent: 800 | Response: 76%</span>
                    </div>
                  </div>
                  <div className="id-channel-stat-row"><span>Messages Sent</span><strong>800</strong></div>
                  <div className="id-channel-stat-row"><span>Messages Received</span><strong>750</strong></div>
                  <div className="id-channel-stat-row"><span>Delivered</span><strong>780 (97%)</strong></div>
                  <div className="id-channel-stat-row"><span>Read Rate</span><strong>710 (88%)</strong></div>
                  <div className="id-channel-stat-row"><span>Replied</span><strong>610 (76%)</strong></div>
                </div>
              </div>

              {/* Calls */}
              <div className="col-lg-4 col-md-6">
                <div className="id-channel-card h-100">
                  <div className="id-channel-header">
                    <div className="id-channel-icon call"><FaPhoneAlt /></div>
                    <div>
                      <h6 className="mb-0 font-weight-bold text-dark">Telephonic Calls</h6>
                      <span className="text-muted small">Total: 710 | Response: 84%</span>
                    </div>
                  </div>
                  <div className="id-channel-stat-row"><span>Incoming Calls</span><strong>280</strong></div>
                  <div className="id-channel-stat-row"><span>Outgoing Calls</span><strong>430</strong></div>
                  <div className="id-channel-stat-row"><span>Missed Calls</span><strong>35</strong></div>
                  <div className="id-channel-stat-row"><span>Connected Calls</span><strong>360 (84%)</strong></div>
                  <div className="id-channel-stat-row"><span>Avg Duration</span><strong>4m 15s</strong></div>
                </div>
              </div>

              {/* Channel Effectiveness Table */}
              <div className="col-12 mt-3">
                <div className="id-card">
                  <div className="id-card-header">
                    <h6>Channel Communication Effectiveness Matrix</h6>
                  </div>
                  <div className="id-card-body p-0">
                    <div className="table-responsive">
                      <table className="table table-hover mb-0 align-middle">
                        <thead className="table-light">
                          <tr>
                            <th>Channel</th>
                            <th>Total Sent / Outbound</th>
                            <th>Total Received / Response</th>
                            <th>Response Rate %</th>
                            <th>Avg Response Time</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td><FaEnvelope className="text-primary me-2" /> Email</td>
                            <td>520</td>
                            <td>210</td>
                            <td><span className="badge bg-warning text-dark">40%</span></td>
                            <td>45 Mins</td>
                          </tr>
                          <tr>
                            <td><FaWhatsapp className="text-success me-2" /> WhatsApp</td>
                            <td>800</td>
                            <td>610</td>
                            <td><span className="badge bg-success">76%</span></td>
                            <td>8 Mins</td>
                          </tr>
                          <tr>
                            <td><FaPhoneAlt className="text-info me-2" /> Phone Call</td>
                            <td>430</td>
                            <td>360</td>
                            <td><span className="badge bg-primary">84%</span></td>
                            <td>Instant (Live)</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* TAB 6: PRODUCT KPIS */}
          {activeTab === "products" && (
            <div className="row mb-4 g-3">
              <div className="col-lg-8">
                <div className="id-card h-100">
                  <div className="id-card-header">
                    <h6>Product-wise Interaction Volume</h6>
                  </div>
                  <div className="id-card-body p-3">
                    <div style={{ height: "260px" }}>
                      <Bar data={productChartData} options={{ maintainAspectRatio: false }} />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4">
                <div className="id-card h-100">
                  <div className="id-card-header">
                    <h6>Product Insights</h6>
                  </div>
                  <div className="id-card-body p-3">
                    <div className="mb-3">
                      <span className="text-muted small d-block">Most Discussed Product</span>
                      <strong className="h5 text-primary font-weight-bold">ERP (420 Interactions)</strong>
                    </div>
                    <div className="mb-3">
                      <span className="text-muted small d-block">Least Discussed Product</span>
                      <strong className="h5 text-secondary font-weight-bold">EyeSense (95 Interactions)</strong>
                    </div>
                    <div className="mb-3">
                      <span className="text-muted small d-block">Sales vs Support Enquiries</span>
                      <strong className="h6 text-dark">740 Sales / 480 Support</strong>
                    </div>
                    <div>
                      <span className="text-muted small d-block">Demo Requests Generated</span>
                      <strong className="h5 text-success font-weight-bold">240 Demos</strong>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* TAB 7: AI INSIGHTS & EMPLOYEE PERFORMANCE */}
          {activeTab === "ai" && (
            <div className="row mb-4 g-3">
              {/* Employee Performance Table */}
              <div className="col-lg-7">
                <div className="id-card h-100">
                  <div className="id-card-header">
                    <h6>Employee Workload & Performance Leaderboard</h6>
                  </div>
                  <div className="id-card-body p-0">
                    <div className="table-responsive">
                      <table className="table table-hover mb-0 align-middle">
                        <thead className="table-light">
                          <tr>
                            <th>Employee</th>
                            <th>Calls</th>
                            <th>WhatsApp</th>
                            <th>Email</th>
                            <th>Meetings</th>
                            <th>Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td><strong>Sarah Smith</strong></td>
                            <td>140</td>
                            <td>180</td>
                            <td>110</td>
                            <td>25</td>
                            <td><span className="badge bg-primary">455</span></td>
                          </tr>
                          <tr>
                            <td><strong>John Doe</strong></td>
                            <td>120</td>
                            <td>160</td>
                            <td>95</td>
                            <td>30</td>
                            <td><span className="badge bg-primary">405</span></td>
                          </tr>
                          <tr>
                            <td><strong>Emily Davis</strong></td>
                            <td>75</td>
                            <td>130</td>
                            <td>135</td>
                            <td>12</td>
                            <td><span className="badge bg-primary">352</span></td>
                          </tr>
                          <tr>
                            <td><strong>Alex Johnson</strong></td>
                            <td>95</td>
                            <td>140</td>
                            <td>80</td>
                            <td>18</td>
                            <td><span className="badge bg-primary">333</span></td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              {/* AI Smart Recommendations */}
              <div className="col-lg-5">
                <div className="id-ai-card h-100">
                  <h6 className="d-flex align-items-center gap-2 mb-3">
                    <FaRobot style={{ fontSize: "1.2rem" }} />
                    AI Smart Recommendations & Insights
                  </h6>

                  <div className="id-ai-item">
                    <strong className="text-warning d-block mb-1">⚡ Immediate Action Needed</strong>
                    12 high-intent leads are pending follow-up for &gt;4 hours. High conversion potential.
                  </div>

                  <div className="id-ai-item">
                    <strong className="text-info d-block mb-1">💡 Optimal Contact Window</strong>
                    Calls placed between <strong>10:30 AM – 12:00 PM</strong> show an 84% connection rate.
                  </div>

                  <div className="id-ai-item">
                    <strong className="text-danger d-block mb-1">⚠️ Churn Risk Alert</strong>
                    3 Enterprise customer accounts have had zero interactions in the last 90 days.
                  </div>

                  <div className="id-ai-item">
                    <strong className="text-success d-block mb-1">📈 High Performing Channel</strong>
                    WhatsApp messaging yields 76% response rate compared to 40% on Email.
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Global Search & Multi-Criteria Filter Bar */}
          <div className="id-filter-bar mb-4">
            <div className="row g-3 align-items-center">
              <div className="col-lg-3 col-md-6">
                <div className="position-relative">
                  <FaSearch className="id-search-icon" />
                  <input
                    ref={searchInputRef}
                    type="text"
                    className="form-control id-search-input"
                    placeholder="Search by ID, Customer, Type, Product, Priority, User..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                  {searchTerm && (
                    <button
                      type="button"
                      className="btn btn-link btn-sm text-muted position-absolute end-0 top-50 translate-middle-y me-2 p-0 border-0"
                      onClick={() => setSearchTerm("")}
                      style={{ right: "10px", zIndex: 3 }}
                    >
                      <FaTimes />
                    </button>
                  )}
                </div>
              </div>

              <div className="col-lg-2 col-md-3 col-6">
                <select
                  className="form-select id-select w-100"
                  value={selectedEntity}
                  onChange={(e) => setSelectedEntity(e.target.value)}
                >
                  <option value="All">Entity: All</option>
                  <option value="Lead">Lead</option>
                  <option value="Customer">Customer</option>
                  <option value="Vendor">Vendor</option>
                </select>
              </div>

              <div className="col-lg-2 col-md-3 col-6">
                <select
                  className="form-select id-select w-100"
                  value={selectedDirection}
                  onChange={(e) => setSelectedDirection(e.target.value)}
                >
                  <option value="All">Direction: All</option>
                  <option value="Inbound">Inbound</option>
                  <option value="Outbound">Outbound</option>
                </select>
              </div>

              <div className="col-lg-2 col-md-3 col-6">
                <select
                  className="form-select id-select w-100"
                  value={selectedChannel}
                  onChange={(e) => setSelectedChannel(e.target.value)}
                >
                  <option value="All">Channel: All</option>
                  <option value="Call">Call</option>
                  <option value="WhatsApp">WhatsApp</option>
                  <option value="Email">Email</option>
                </select>
              </div>

              <div className="col-lg-2 col-md-3 col-6">
                <select
                  className="form-select id-select w-100"
                  value={selectedProduct}
                  onChange={(e) => setSelectedProduct(e.target.value)}
                >
                  <option value="All">Product: All</option>
                  <option value="CRM">CRM</option>
                  <option value="ERP">ERP</option>
                  <option value="HRM">HRM</option>
                  <option value="Accounting">Accounting</option>
                  <option value="General">General</option>
                </select>
              </div>

              <div className="col-lg-1 col-md-3 col-12 text-end">
                {(searchTerm || selectedEntity !== "All" || selectedDirection !== "All" || selectedChannel !== "All" || selectedProduct !== "All") && (
                  <button className="btn btn-outline-danger btn-sm w-100" onClick={clearAllFilters} title="Clear Filters">
                    <FaTimes />
                  </button>
                )}
              </div>
            </div>
          </div>

          {/* Interactions Listing / Empty State */}
          <div className="id-card">
            <div className="id-card-header d-flex align-items-center justify-content-between">
              <h6>
                <FaComments className="text-info mr-2" />
                Detailed Interaction Records Listing
              </h6>
              <span className="badge bg-light text-dark font-weight-normal px-2 py-1 border">
                Showing {filteredInteractions.length} of {totalCount} records
              </span>
            </div>

            <div className="id-card-body p-3">
              {loading ? (
                <div className="text-center py-5">
                  <div className="spinner-border text-info" role="status"></div>
                  <p className="mt-2 text-muted small">Loading interaction records...</p>
                </div>
              ) : filteredInteractions.length === 0 ? (
                <div className="id-empty-state">
                  <div className="id-empty-icon">
                    <FaPhoneSlash />
                  </div>
                  <h5 className="font-weight-bold text-dark mb-1">No interactions found</h5>
                  <p className="text-muted small mb-3">
                    {searchTerm || selectedEntity !== "All" || selectedDirection !== "All" || selectedStatus !== "All" || selectedProduct !== "All"
                      ? `No interaction records match your current search "${searchTerm}" or active filters.`
                      : "No interaction records have been created yet."}
                  </p>
                  <div className="d-flex justify-content-center gap-2 flex-wrap">
                    {(searchTerm || selectedEntity !== "All" || selectedDirection !== "All" || selectedStatus !== "All" || selectedProduct !== "All") && (
                      <button className="btn btn-outline-secondary btn-sm" onClick={clearAllFilters}>
                        <FaTimes className="mr-1" /> Clear Search & Filters
                      </button>
                    )}
                    <button className="btn btn-id-primary btn-sm" onClick={() => setIsCreateModalOpen(true)}>
                      <FaPlus className="mr-1" /> Create Interaction Record
                    </button>
                  </div>
                </div>
              ) : (
                <InteractionRecord tableData={filteredInteractions} />
              )}
            </div>
          </div>
        </div>

        <UserFooter />
      </div>

      {/* Modal Integration */}
      <CreateInteractionRecordModal
        open={isCreateModalOpen}
        onClose={() => setIsCreateModalOpen(false)}
        onInteractionCreated={handleInteractionCreated}
      />
    </div>
  );
}
